module.exports = __webpack_public_path__ + "img/delImg.4e85920e.svg";